import { render, staticRenderFns } from "./product-card-flow.vue?vue&type=template&id=75380743&"
import script from "./product-card-flow.vue?vue&type=script&lang=js&"
export * from "./product-card-flow.vue?vue&type=script&lang=js&"
import style0 from "./product-card-flow.vue?vue&type=style&index=0&id=75380743&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports